import { Anchor, Box, Divider, Group, Loading } from '@byecode/ui'
import { Select } from '@byecode/ui'
import type { FlowNode, NodeTypes, WechatSubscriptionMessageConfig } from '@lighthouse/shared'
import { ListItem4ByecodeUi, nodeTypeOptions, workflowGuidanceDocumentMap } from '@lighthouse/shared'
import React, { useMemo } from 'react'

import { useCurrentAppId } from '@/hooks/useApplication'
import { useGetWxMiniProgramMessageInfo } from '@/shared/reusable'

import { GroupRequired } from '../../Common/GroupRequired'
import * as CM from '../../styles'
import { SelectTemplateMsg } from './SelectTemplateMsg'
import * as SC from './styles'

interface WxSubscriptionActionConfigureProps {
    nodeType?: NodeTypes
    allParentNodes?: FlowNode[]
    actionTypeSwitcher?: React.ReactNode
    value: WechatSubscriptionMessageConfig
    onChange: (value: WechatSubscriptionMessageConfig) => void
}

export const WxSubscriptionActionConfigure: React.FC<WxSubscriptionActionConfigureProps> = ({
    actionTypeSwitcher,
    nodeType,
    value,
    onChange
}) => {
    const appId = useCurrentAppId()
    const { data, isLoading } = useGetWxMiniProgramMessageInfo(appId)

    const header = useMemo(() => {
        if (!actionTypeSwitcher) {
            return null
        }
        return (
            <>
                <Group label="动作配置">
                    <ListItem4ByecodeUi>
                        <CM.FormItemLabelWrapper>
                            <CM.FormItemLabel>类型</CM.FormItemLabel>
                        </CM.FormItemLabelWrapper>
                        <CM.FormItemContent>{actionTypeSwitcher}</CM.FormItemContent>
                    </ListItem4ByecodeUi>
                </Group>
                <Divider />
            </>
        )
    }, [actionTypeSwitcher])

    // if (!wechatAccount) {
    //     return (
    //         <>
    //             {header}
    //             <UnitNoAuth type="WECHAT_OFFICIAL_ACCOUNT" />
    //         </>
    //     )
    // }

    return (
        <CM.Container>
            {header}
            {!actionTypeSwitcher && (
                <>
                    <Divider color="var(--color-gray-200)" />
                    <Group label="动作配置">
                        <ListItem4ByecodeUi>
                            <CM.FormItemLabelWrapper>
                                <CM.FormItemLabel>类型</CM.FormItemLabel>
                            </CM.FormItemLabelWrapper>
                            <CM.FormItemContent>
                                <Select disabled value={nodeType} options={nodeTypeOptions} />
                            </CM.FormItemContent>
                        </ListItem4ByecodeUi>
                    </Group>
                </>
            )}
            <GroupRequired label="订阅消息模板" required>
                {isLoading ? (
                    <Loading />
                ) : (
                    <Box px={8}>
                        <SC.SelectContainer>
                            <SelectTemplateMsg
                                value={value.templateIds}
                                data={data}
                                onChange={templateIds => onChange({ ...value, templateIds })}
                            />
                        </SC.SelectContainer>
                        <SC.Description mt={6}>
                            模板消息需在小程序中配置{' '}
                            <Anchor to={workflowGuidanceDocumentMap.WECHAT_SUBSCRIPTION_MSG_ACTION.url} target="_blank">
                                详见
                            </Anchor>
                        </SC.Description>
                    </Box>
                )}
            </GroupRequired>
        </CM.Container>
    )
}
